import $api from '../../utils/api.js'


const state = () => ({
    category: {
        total: 0,
        per_page: 2,
        from: 1,
        to: 0,
        current_page: 1
    },
    sorting: {
        num:10,
        search: '',
        type:'',
        offset: 4,
        sort:'desc',
        placeholder:'Search Category'
    },
    formdata:{
        id:'',
        name:'',
        image_cover_url:'',
        meta_keywords:'',
        meta_description:'',
        meta_title:'',
    },
    errors:[],
})

const mutations = {
    ASSIGN_DATA(state, payload) {
        state.category = payload
    },
    ASSIGN_FORM(state, payload) {
        state.formdata = {
            id:payload.id,
            name:payload.name,
            image_cover_url:payload.image_cover_url,
            meta_keywords:payload.meta_keywords,
            meta_description:payload.meta_description,
            meta_title:payload.meta_title,
        }
    },
    CLEAR_FORM(state) {
        state.formdata = {
            id:'',
            name:'',
            image_cover_url:'',
            meta_keywords:'',
            meta_description:'',
            meta_title:'',
        },
        state.errors = []
    },
    CLEAR_CATEGORY(state){
        state.category = {
            total: 0,
            per_page: 2,
            from: 1,
            to: 0,
            current_page: 1,
        },
        state.sorting =  {
            num:10,
            search: '',
            type:'',
            offset: 4,
            sort:'desc',
            placeholder:'Search Category',
        }
    },
    SET_ERRORS(state, payload) {
        state.errors = payload
    },
}

const actions = {
    getCategory({ commit, state }) {
        return new Promise((resolve) => {
            $api.get(`category?type=${state.sorting.type}&page=${state.category.current_page}&paginate=${state.sorting.num}&search=${state.sorting.search}&sort=${state.sorting.sort}`)
            .then((response) => {
                commit('ASSIGN_DATA', response.data)
                resolve(response.data)
            })
        })
    },
    createCategory({ commit }, payload) {
        return new Promise((resolve) => {
            $api.post(`category`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
            })
        })
    },
    editCategory({ commit }, payload) {
        return new Promise((resolve) => {
            $api.get(`category?id=${payload}`)
            .then((response) => {
                commit('ASSIGN_FORM', response.data)
                resolve(response.data)
            })
        })
    },
    updateCategory({ state,commit }, payload) {
        return new Promise((resolve) => {
            $api.post(`category/${state.formdata.id}`, payload.formData)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
            })
        })
    },
    deleteCategory({ dispatch }, payload) {
        return new Promise((resolve) => {
            $api.delete(`category/${payload}`)
            .then(() => {
                dispatch('getCategory').then(() => resolve())
            })
        })
    },
    
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}